import { render, staticRenderFns } from "./event-list-item.vue?vue&type=template&id=2ef35ae1&"
import script from "./event-list-item.vue?vue&type=script&lang=js&"
export * from "./event-list-item.vue?vue&type=script&lang=js&"
import style0 from "./event-list-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./event-list-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports